import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle,FormControl,InputLabel,Select,MenuItem} from "@mui/material";
import FunctionsData from "../../../Functions/FunctionsData";

export default function StaffVoucherCancelVoucher({open,setOpen, voucher, setLoadingVouchers}) {

    const [accept, setAccept] = React.useState(false);
    const [email, setEmail] = React.useState(false);
      const [reason, setReason] = React.useState("");
     
    async function addVouchers(voucher) {
        // setBtnAddDisabled(true)
        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/campaign/vouchers/addWithCampaign'),
            {
                voucherId: voucher.voucher_id,
                campaignId: voucher.campaign_id
            }
        )
            .then((r) => {
               
            })
    }
    function removeRedemption() {
        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/voucher/cancelVoucher/')+voucher.voucher_id,
            {email})
            .then(data => {
                console.log(data);
                setLoadingVouchers(true);
                setOpen(false);
                addVouchers(voucher);
            })
            .catch(err => {
                console.log(err);
            })
    }

    return (
        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>Cancel Voucher</DialogTitle>
            <DialogContent>
                <div style={{padding:'0 20px'}}>
                    <ul>
                        <li>Serial: {voucher.voucher_nr}</li>
                        <li>Name: {voucher.a_name}</li>
                        <li>Animal: {voucher.a_type} {voucher.animal_gender}</li>
                        <li>Redeemed on: {voucher.transaction_date}</li>
                        <li>Surgery on: {voucher.a_date_surgery}</li>
                        <li>Surgery: {voucher.a_type_surgery}</li>
                        <li>Surgery amount: NZD {voucher.a_surgery_amount}</li>
                        <li>Vet: {voucher.supplier_business_name}</li>
                        <li>Campaign: {voucher.campaign_name}</li>
                    </ul>
                </div>
                <div style={{ marginTop: 20 }}>
          <FormControl fullWidth>
            <InputLabel id="reason-select-label">Reason</InputLabel>
            <Select
              labelId="reason-select-label"
              id="reason-select"
              value={reason}
              label="Reason"
              onChange={(e) => setReason(e.target.value)}
            >
              <MenuItem value="Deceased">Deceased</MenuItem>
              <MenuItem value="Rescue">Rescue</MenuItem>
              <MenuItem value="Not needed">Not needed</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
          </FormControl>
        </div>
                <div style={{marginTop:20}}>
                    <input type={"checkbox"} onChange={(e) => setAccept(e.target.checked)} /> I understand that this action cannot be undone.
                </div>
                <div style={{marginTop:20}}>
                    <input type={"checkbox"} onChange={(e) => setEmail(e.target.checked)} /> Notify Owner via email.
                </div>

            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>Cancel</Button>
                <Button variant={"contained"} disabled={!accept} onClick={removeRedemption}>Remove Voucher</Button>
            </DialogActions>
        </Dialog>
    )
}
